import { faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Id from 'models/id';
import { Trans } from 'react-i18next';
import 'scss/Main.scss';
import ClientCrossLinksModal from './ClientCrossLinksModal';

type ClientCrossLinksBtnProps = Id & {
    isOpen?: boolean;
    toggle: (item: string) => void;
};

export default function ClientCrossLinksBtn({
    id,
    toggle,
    isOpen = false,
}: ClientCrossLinksBtnProps) {
    return (
        <>
            <div
                className="workplace-action-btn cursor--pointer"
                onClick={() => {
                    toggle(id?.toString() || '');
                }}
            >
                <FontAwesomeIcon
                    icon={faAddressCard}
                    className="text-info workplace-action-btn__icon"
                />
                <span>
                    <Trans i18nKey="BackOfficeCrossLinks" />
                </span>
            </div>
            <ClientCrossLinksModal id={id} toggle={toggle} isOpen={isOpen}></ClientCrossLinksModal>
        </>
    );
}
